import React from 'react';
import Header from '../HeaderSection/Header';
import Breadcrumb from '../Blogs/Breadcrumb';
import FeatureSection from '../Features/FeatureOne';
import FooterSection from '../FooterSection/Footer';

const Features = () => {
    return (
        <div>
            {/*====== Scroll To Top Area Start ======*/}
            <div id="scrollUp" title="Scroll To Top">
                <i className="fas fa-arrow-up" />
            </div>
            {/*====== Scroll To Top Area End ======*/}
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                <Breadcrumb title="Features" breadcrumbPath={[]} />
                <FeatureSection />
                <FooterSection />
            </div>
        </div>
    );
}

export default Features; 